import { gql } from '@apollo/client';

export const ParagraphAuthorsFragment = gql`
  fragment ParagraphAuthors on ParagraphAuthors {
    id
  }
`;
